import lodashGet from 'lodash/get';
import { addToExperiments } from './addToExperiments';
/**
 * Get 2D experiments containing zones.
 *
 * @param {Spectra} spectraData
 */
export function getExperiments2D(experiments) {
    const _experiments2D = {};
    Object.keys(lodashGet(experiments, '2D', {})).forEach((experimentType) => {
        addToExperiments(experiments, _experiments2D, `2D.${experimentType}`, false, experimentType);
    });
    return _experiments2D;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0RXhwZXJpbWVudHMyRC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsaXRpZXMvZXhwZXJpbWVudC9nZXRFeHBlcmltZW50czJELnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sU0FBUyxNQUFNLFlBQVksQ0FBQztBQUtuQyxPQUFPLEVBQUUsZ0JBQWdCLEVBQUUsTUFBTSxvQkFBb0IsQ0FBQztBQUV0RDs7OztHQUlHO0FBQ0gsTUFBTSxVQUFVLGdCQUFnQixDQUFDLFdBQXdCO0lBQ3ZELE1BQU0sY0FBYyxHQUFvQixFQUFFLENBQUM7SUFDM0MsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsV0FBVyxFQUFFLElBQUksRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDLGNBQWMsRUFBRSxFQUFFO1FBQ3ZFLGdCQUFnQixDQUNkLFdBQVcsRUFDWCxjQUFjLEVBQ2QsTUFBTSxjQUFjLEVBQUUsRUFDdEIsS0FBSyxFQUNMLGNBQWMsQ0FDZixDQUFDO0lBQ0osQ0FBQyxDQUFDLENBQUM7SUFFSCxPQUFPLGNBQWMsQ0FBQztBQUN4QixDQUFDIn0=